import React, { useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { getCompanies } from '../utils/api/companies';
import globalErrorHandler from '../utils/globalErrorHandler';
import { Company } from '../interfaces/InsuranceCompanyAgent';

interface CompanyAutocompleteProps {
    onSelect: (company: Company | null) => void;
    value?: Company | null;
    placeholder?: string;
    disabled?: boolean;
}

const CompanyAutocomplete: React.FC<CompanyAutocompleteProps> = ({ onSelect, value, placeholder = 'Search company...', disabled = false }) => {
    const [search, setSearch] = useState<string>('');
    const [autocompleteOptions, setAutocompleteOptions] = useState<Company[]>([]);
    const [loading, setLoading] = useState(false);

    const onSearchTextChanged = async (search: string) => {
        if (search === undefined) return;

        setSearch(search);

        if (search === '') {
            setAutocompleteOptions([]);
            return;
        }

        try {
            setLoading(true);
            const { companies } = await getCompanies({ search });
            setAutocompleteOptions(companies || []);
        } catch (err) {
            globalErrorHandler(err);
        } finally {
            setLoading(false);
        }
    };

    const handleSelect = (option: Company | null) => {
        onSelect(option);
    };

    return (
        <Autocomplete
            size="small"
            loading={loading}
            options={autocompleteOptions}
            value={value}
            disabled={disabled}
            getOptionLabel={(option: Company) => option.name || ''}
            isOptionEqualToValue={(option, value) => option._id === value._id}
            onInputChange={(event, newInputValue) => {
                onSearchTextChanged(newInputValue);
            }}
            onChange={(event, newValue) => {
                handleSelect(newValue);
            }}
            renderInput={(params) => <TextField {...params} placeholder={placeholder} />}
        />
    );
};

export default CompanyAutocomplete;
